import Navbar from './Navbar'
import Home from './Home'
import Terms from './Terms'
import MemberSignUp from './MemberSignUp'
import VenueSignUp from './VenueSignUp'
import Login from './Login'
import Rules from './Rules'
import Enter from './Enter'
import MemberInfo from './MemberInfo'
import VenueInfo from './VenueInfo'

import { BrowserRouter as Router, Route } from 'react-router-dom'

function App() {
  return (
    <Router>

      <Route path="/">
        <Navbar />
      </Route>

      <Route exact path="/">
        <Home />
      </Route>

      <Route path="/venue-sign-up">
        <VenueInfo />
      </Route>
      {/* LOGIN & SIGNUP ARE COMBINED IN 'ENTER' COMPONENT*/}
      <Route path="/login">
        <Login />
      </Route>
      {/* LOGIN & SIGNUP ARE COMBINED IN 'ENTER' COMPONENT*/}
      {/* <Route path="/sign-up">
        <MemberSignUp />
      </Route> */}

      <Route path="/terms-conditions">
        <Terms />
      </Route>


      <Route path="/memberships">
        <MemberInfo />
      </Route>

      <Route path="/rules">
        <Rules />
      </Route>

      <Route path="/enter">
        <Enter />
      </Route>

    </Router>
  )
}

export default App